import { render, staticRenderFns } from "./Corrections.vue?vue&type=template&id=61e564de&scoped=true"
import script from "./Corrections.vue?vue&type=script&lang=js"
export * from "./Corrections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e564de",
  null
  
)

export default component.exports